// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2156 ? "e99863e0" : chunkId) + "." + {"1025":"9f6136b7a6c5a453","2156":"57386bc28390d07a"}[chunkId] + ".js";
};